  <div class="container-fluid page-content">

    <div class="row">
      <div class="col">
        <label class="title"> Familias </label>
      </div>
    </div>

    <div class="row">
      <div class="col text-end">
        <button (click)="abrirModalCrearFamiliaEquipo();" class="btn btn-sm btn-success rounded-button">
          <i class="fas fa-plus"> </i> &nbsp;
          Nueva Familia
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <p-table #dt [value]="lista" [scrollable]="true" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="valor" style="border-top-left-radius: 15px;" class="medium-col">Valor</th>
            <th pSortableColumn="descripcion" class="medium-col">Descripción</th>
            <th pSortableColumn="activo" class="small-col">Estatus</th>
            <th class="medium-col" style="border-top-right-radius: 15px;">Acción</th>
          </tr>

          <tr class="filter-row">
            <th>
              <input placeholder="Filtrar" #filtroValor type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroValor.value, 'valor', 'contains')">

            </th>
            <th class="filter-row">
              <input placeholder="Filtrar" type="text" #filtroDescripcion class="form-input form-input-table-filter" (input)="dt.filter(filtroDescripcion.value, 'descripcion', 'contains')">
            </th>
            <th class="filter-row">
              <select #filtroActivo (input)="dt.filter(filtroActivo.value, 'activo', 'equals')" style="padding: 3px; width: 85%;" class="form-input form-input-table-filter text-center">
                <option value="">Todos</option>
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
            </th>

            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" class="animated fadeIn fast" let-familia>

          <tr>
            <td class="medium-col">{{ familia.descripcion }}</td>
            <td class="medium-col">{{familia.valor}}</td>
            <td class="small-col">
              @if (familia.activo) {
                <i matTooltip="Activo" [matTooltipClass]="{ 'custom-tooltip': true }" class="fas fa-check green"></i>
              }
              @if (!familia.activo) {
                <i matTooltip="Inactivo" [matTooltipClass]="{ 'custom-tooltip': true }" class="fas fa-ban red"></i>
              }
            </td>

            <td class="medium-col" (click)="abrirModalEditarFamiliaEquipo(familia)">
              <button type="button" style="font-size:12px; width: 100px;" class="btn btn-xs my-button-blue-outline rounded-button">
                <i class="far fa-edit"></i>&nbsp;
                Editar
              </button>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>


  </div>